export enum ScreenType {
  COVER_SHEET = 'CoverSheet',
  EMAIL = 'Email',
  KINETIC = 'Kinetic Email',
}
